var _rect, _line, _line2, _line3, _line4, _ellipse, _path, _path2, _path3, _path4, _path5, _ellipse2, _ellipse3, _circle, _circle2, _circle3, _circle4, _path6, _rect2, _path7, _path8, _ellipse4, _ellipse5, _circle5, _circle6, _g, _ellipse6, _ellipse7, _ellipse8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimeCharacter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 600,
    viewBox: "0 0 400 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 600,
    fill: "#190A4E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 100,
    y2: 150,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 0,
    x2: 150,
    y2: 200,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 300,
    y2: 150,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 0,
    x2: 250,
    y2: 200,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 65,
    ry: 75,
    fill: "#FFB02E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 150 Q200 100 265 150 L265 190 Q240 170 200 165 Q160 170 135 190 Z",
    fill: "#E09920"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 140 L160 180",
    stroke: "#190A4E",
    strokeWidth: 3,
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 130 L185 170",
    stroke: "#190A4E",
    strokeWidth: 3,
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 130 L215 170",
    stroke: "#190A4E",
    strokeWidth: 3,
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250 140 L240 180",
    stroke: "#190A4E",
    strokeWidth: 3,
    opacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 185,
    rx: 15,
    ry: 20,
    fill: "#190A4E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225,
    cy: 185,
    rx: 15,
    ry: 20,
    fill: "#190A4E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 182,
    r: 5,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 182,
    r: 5,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 190,
    r: 3,
    fill: "#00D9FF",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 190,
    r: 3,
    fill: "#00D9FF",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195 210 Q200 215 205 210",
    stroke: "#190A4E",
    strokeWidth: 2,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 245,
    width: 30,
    height: 40,
    fill: "#FFB02E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140 285 Q200 300 260 285 L270 450 Q200 440 130 450 Z",
    fill: "#00D9FF",
    opacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185 285 L200 295 L215 285",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "none"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 350,
    rx: 18,
    ry: 80,
    fill: "#FFB02E"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 350,
    rx: 18,
    ry: 80,
    fill: "#FFB02E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 420,
    r: 15,
    fill: "#FFB02E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 420,
    r: 15,
    fill: "#FFB02E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320,150 325,160 335,165 325,170 320,180 315,170 305,165 315,160"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80,200 83,206 89,209 83,212 80,218 77,212 71,209 77,206"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340,320 343,325 348,327 343,330 340,335 337,330 332,327 337,325"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155,
    cy: 200,
    rx: 12,
    ry: 6,
    fill: "#FF6B9D",
    opacity: 0.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245,
    cy: 200,
    rx: 12,
    ry: 6,
    fill: "#FF6B9D",
    opacity: 0.3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 100,
    rx: 50,
    ry: 30,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290 115 L270 130 L285 120 Z",
    fill: "#FFFFFF",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimeCharacter);
export default __webpack_public_path__ + "static/media/anime-character.f7c03318b2926291fbd30f34bfed8d25.svg";
export { ForwardRef as ReactComponent };